import { render, staticRenderFns } from "./ProdTech.vue?vue&type=template&id=77c21f45&scoped=true&"
import script from "./ProdTech.vue?vue&type=script&lang=js&"
export * from "./ProdTech.vue?vue&type=script&lang=js&"
import style0 from "./ProdTech.vue?vue&type=style&index=0&id=77c21f45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c21f45",
  null
  
)

export default component.exports